import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        counties: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {
                    name: [],
                }
            }
        },
        has_errors: false,
        loading: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        counties: state => state.counties,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        loading: state => state.loading
    },
    mutations: {
        setLoading(state, status) {
            state.loading = status
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setCounties(state, data) {
            state.counties = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            name: [],
                        }
                    }
                };
            }
        }
    },
    actions: {
        async getCounties({commit}, filters) {
            try {
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getCounties(filters);
                commit('setCounties', response);
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async createCounties({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createCounties(data);
                dispatch('getCounties', {
                    paginate: true
                })
                ElMessage.success('County created successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error creating County!');
            }
        },
        async editCounty({dispatch, commit}, data) {
            try {
                await api.editCounty(data);
                dispatch('getCounties', {
                    paginate: true
                });
                commit('hasErrors', false)
                ElMessage.success('County updated successfully!');
            } catch (e) {
                commit('setErrors', e.response)
                commit('hasErrors', true)
                ElMessage.error('Error updating County');
            }
        },
        
        async deleteCounty({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                await api.deleteCounty(data);
                dispatch('getCounties', {
                    paginate: true
                });
                ElMessage.success('County removed successfully!');
            } catch (e) {
                ElMessage.error('Error removing County');
            }
        },


    }
}
